import { useEffect, useState } from "react";
import ActiveSessionLookup from "./components/ActiveSessionLookup";
import LoginPage from "./components/LoginPage";
import Header from "./components/Header";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:4000/api";

export default function App() {
  const [loggedIn, setLoggedIn] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/session`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        setLoggedIn(!!data.loggedIn);
        setUser(data.user || null);
      })
      .catch(() => setLoggedIn(false));
  }, []);

  const handleLogout = async () => {
    await fetch(`${API_BASE}/logout`, { method: "POST", credentials: "include" }).catch(() => {});
    setLoggedIn(false);
    setUser(null);
  };

  if (loggedIn === null) {
    return null;
  }

  if (!loggedIn) {
    return (
      <LoginPage
        onLoginSuccess={(loggedInUser) => {
          setUser(loggedInUser);
          setLoggedIn(true);
        }}
      />
    );
  }

  return (
    <>
      <Header user={user} onLogout={handleLogout} />
      <ActiveSessionLookup onSessionExpired={() => setLoggedIn(false)} />
    </>
  );
}
